import { ActionType, getType } from 'typesafe-actions'
import * as actions from 'components/main/actions'
import { SubmissionStatus } from 'types/submissionStatus'

export const completenessReducer = (
  state: boolean = false,
  action: ActionType<typeof actions>
) => {
  switch (action.type) {
    case getType(actions.setCompleteness):
      return action.payload
  }

  return state
}

export const submissionStatusReducer = (
  state: SubmissionStatus = 'fillingOut',
  action: ActionType<typeof actions>
) => {
  switch (action.type) {
    case getType(actions.setSubmissionStatus):
      return action.payload
  }

  return state
}
